import { isNotNullOrEmptyString } from "@dirootie-extensions/javascript";
import { useNavigate } from "react-router-dom";
import { Header, ILevel1Link } from "taltech-styleguide";
import { LayoutConfiguration } from "../../../configuration/AreaConfiguration";
import { LinkBehaviour } from "./LinkBehavior";

export const NavBarTop: React.FC<any> = (
  props: LayoutConfiguration & {
    profile: {
      firstName: string;
      lastName: string;
      photo: string;
      role: string;
    };
    menuItems: any;
  }
) => {
  const newLinks = (props?.menuItems ?? []).map((x: any) => {
    if (x.label === "Management") {
      x.to = "/management";
    }
    return {
      children: x.label,
      to: x.to,
    };
  });
  const navigator = useNavigate();
  const links: ILevel1Link[] = [
    {
      active: true,
      children: "Workplace",
      items: newLinks,
      to: "/",
    },
    {
      active: false,
      children: "TalTech",
      target: "_blank",
      to: "https://taltech.ee/en/",
    },
  ];
  const showProfile = false; //props.menuProfile?.children !== undefined;
  const headerClass = `edb-header` + (showProfile ? "" : " edb-header-basic");
  const logoRoute = isNotNullOrEmptyString(props.route) ? props.route : "";
  return (
    <Header
      linkAs={LinkBehaviour as any}
      className={headerClass}
      logoLink={{
        href: logoRoute,
        children: "Logo aria",
      }}
      links={links}
      profile={
        showProfile
          ? {
              profile: props.profile,
              links: props.menuProfile?.children!.filter(
                (x: any) =>
                  x.roles === undefined ||
                  x.roles.length === 0 ||
                  x.roles!.findIndex((x: any) => x === props.profile!.role) > -1
              ),
              onLogout: () => navigator("auth/logout"),
            }
          : undefined
      }
      translations={{
        logOut: "Logout",
      }}
    />
  );
};
